// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"547":"0122f194","915":"a0b7c850"}[chunkId] + ".chunk.js";
};